query MyTAStatusChartData {
  kpiMyTaStatuses(orderBy: ID_ASC) {
    nodes {
      title
      amount
      searchHint
    }
  }
}
